import { Invoice, type InvoiceList } from '@kalos/kalos-rpc';
import { useQuery } from '@tanstack/react-query';

import { InvoiceClientService } from '../../tools/helpers';
import { queryKeys } from './constants';
import { type EntityFilter } from './utils';

export type InvoiceFilter = EntityFilter<Invoice>;
export const useInvoiceQuery = ({
  filter = {},
  enabled = true,
}: { filter?: InvoiceFilter; enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: [queryKeys.invoice.root, queryKeys.invoice.getHash(filter)],
    queryFn: () => {
      const req = Invoice.create(filter);
      return InvoiceClientService.Get(req);
    },
    enabled,
  });
};

export const useInvoiceBatchGetQuery = <TSelectData = InvoiceList,>({
  filter = {},
  enabled = true,
  select,
}: {
  filter?: InvoiceFilter;
  enabled?: boolean;
  select?: (data: InvoiceList) => TSelectData;
} = {}) => {
  return useQuery({
    queryKey: [queryKeys.invoice.root, queryKeys.invoice.list, queryKeys.invoice.getHash(filter)],
    queryFn: async () => {
      const req = Invoice.create(filter);
      const result = await InvoiceClientService.BatchGet(req);
      if (!result) {
        throw new Error('Failed to fetch invoices');
      }
      return result;
    },
    enabled,
    select,
  });
};
